import * as React from "react";
import PageHeaderView from "../../body/PageHeaderView";
import PageContentView from "../../body/PageContentView";
import {none, option, Option} from "ts-option";
import {connect} from "react-redux";
import {RootState} from "../../../store/reducer/root/RootState";
import Loading from "../../ui/loading/Loading";
import Toast from "../../helper/Toast";
import {OnFailure, OnSuccess} from "../../../store/action/actionHelpers";
import {Dispatch} from "redux";
import LeadStatusesTable from "./LeadStatusesTable";
import LeadStatus from "../../../model/lead/LeadStatus";
import {updateLeadStatusSortOrder} from "../../../store/action/leadStatus/leadStatus";
import EditLeadStatusModal from "../../leadStatus/modal/EditLeadStatusModal";
import ButtonPrimary from "../../../hiberUiKit/src/atoms/Buttons/ButtonPrimary";

interface ReduxProps {
	/**
	 * All lead statuses.
	 */
	leadStatuses: LeadStatus[];
	/**
	 * Sort order update method
	 * @param {LeadStatus[]} items
	 * @param {OnSuccess} onSuccess
	 * @param {OnFailure} onFailure
	 */
	updateSortOrder: (items: LeadStatus[], onSuccess: OnSuccess, onFailure: OnFailure) => void;
}

interface IComponentState {
	/**
	 * Lead statuses with new sort order.
	 */
	leadStatuses: LeadStatus[];
	/**
	 * Lead status to edit
	 */
	editedLeadStatus: Option<LeadStatus>;
	/**
	 * Indicates if sort order has changed.
	 */
	isDirty: boolean;
}

/**
 * Lead status list component.
 */
class LeadStatusesList extends React.Component<ReduxProps, IComponentState> {

	constructor(props: ReduxProps) {
		super(props);
		this.state = {
			leadStatuses: [],
			editedLeadStatus: none,
			isDirty: false
		};
		this.onSubmitOrder = this.onSubmitOrder.bind(this);
		this.onOrderChange = this.onOrderChange.bind(this);
		this.renderEditItemModal = this.renderEditItemModal.bind(this);
	}

	render() {
		return (
			<React.Fragment>
				<PageHeaderView header={"Lead Statuses"}>
					<ButtonPrimary onClick={() => this.onSubmitOrder(this.state.leadStatuses)}
								   disabled={this.props.leadStatuses.length === 0 || !this.state.isDirty}
								   label={"Save Changes"}
								   variant={"burgundy"}/>
				</PageHeaderView>
				<PageContentView>
					<Loading isLoading={this.props.leadStatuses.length === 0}>
						<LeadStatusesTable leadStatuses={this.props.leadStatuses}
										   onRowClick={(leadStatus) => {this.setState({editedLeadStatus: option(leadStatus)})}}
										   onOrderChange={this.onOrderChange}/>
					</Loading>
					{this.renderEditItemModal()}
				</PageContentView>
			</React.Fragment>
		);
	}

	/**
	 * Submit order change.
	 * @param {LeadStatus[]} items
	 */
	onSubmitOrder(items: LeadStatus[]) {
		this.props.updateSortOrder(
			items,
			() => {
				this.setState({isDirty: false},
					() => {
						Toast.info("Sort order has been updated.", "Update sort order");
					});
			},
			() => {
				Toast.error("Something went wrong. Please try again later.", "Update sort order")
			}
		);
	}

	/**
	 * Sort order change callback.
	 * @param {LeadStatus[]} leadStatuses
	 */
	onOrderChange(leadStatuses: LeadStatus[]) {
		this.setState({leadStatuses, isDirty: true});
	}

	/**
	 * Render modal.
	 */
	renderEditItemModal() {
		if (this.state.editedLeadStatus.isDefined) {
			return (
				<EditLeadStatusModal editedLeadStatus={this.state.editedLeadStatus.get}
									 onSuccess={() => this.setState({editedLeadStatus: none})}
									 onCancel={() => this.setState({editedLeadStatus: none})}/>
			);
		}
	}
}

function mapStateToProps(state: RootState) {
	return {
		leadStatuses: [].concat(state.leadStatus.leadStatuses.getOrElse([]))
	}
}

function mapDispatchToProps(dispatch: Dispatch<any>) {
	return {
		updateSortOrder: (items: LeadStatus[], onSuccess: OnSuccess, onFailure: OnFailure) => dispatch(
			updateLeadStatusSortOrder(items, onSuccess, onFailure)
		)
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(LeadStatusesList)
